module.exports = __webpack_public_path__ + "static/media/mode-2044.c93bd9b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2044.svg
// module id = 1055
// module chunks = 2